var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 9.375V2.5H8.75V17.5H7.5V10.625H3.64375L5.25625 12.2437L4.375 13.125L1.25 10L4.375 6.875L5.25625 7.75625L3.64375 9.375H7.5ZM14.7437 7.75625L15.625 6.875L18.75 10L15.625 13.125L14.7437 12.2437L16.3562 10.625H12.5V17.5H11.25V2.5H12.5V9.375H16.3562L14.7437 7.75625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalScroll);
export default __webpack_public_path__ + "static/media/horizontalScroll.644d3e49116763a94ada904bd7631675.svg";
export { ForwardRef as ReactComponent };